import update from 'immutability-helper';
import {
  USER_LOG_OUT,
  FETCH_MY_COLLECTIONS,
  FETCH_MY_COLLECTIONS_SUCCESS,
  FETCH_SHARED_COLLECTIONS_FOLDERS,
  FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS,
  FETCH_POI_DETAIL_SUCCESS,
  FETCH_POI_DETAIL_FAIL,
  FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK,
  FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
} from './../actions/action_types';
import { POI_DETAIL_TYPE_FOR_COLLECTIONS } from './view_state';
import {
  POI_BANK_NEXT_URL_TYPE_FACEBOOK,
  POI_BANK_NEXT_URL_TYPE_WEB_SITE,
  POI_BANK_NEXT_URL_TYPE_TWITTER,
  POI_BANK_NEXT_URL_TYPE_WIKI,
} from './../utilities/constants';
import {
  CREATE_COLLECTIONS_FOLDER,
  DELETE_COLLECTIONS,
  FETCH_COLLECTIONS_FOLDERS,
  MOVE_COLLECTIONS_TO_FOLDER,
  UPDATE_ALIAS_NAME_COLLECTION,
  UPDATE_FOLDER_NAME_COLLECTION,
  UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION,
} from '../actionTypes/collection';
import { ADD_POI_TO_MY_COLLECTION } from '../actionTypes/poiDetail';
import { TYPE_COLLECTIONS_LIST } from '../constants/collections';

export default (
  state = {
    // collections
    collectionsById: [],
    collectionsByHash: {},
    collectionsSkip: 0,
    collectionsTotalCount: 0,
    collectionsFoldersById: [],
    collectionsFoldersByHash: {},
    collectionsFoldersTotalCount: 0,
    sharedFoldersById: [],
    sharedFoldersByHash: {},
    sharedFoldersSkip: 0,
    sharedFoldersTotalCount: 0,
    poiDetail: null,
    latestAddedId: null,
  },
  action,
) => {
  // console.log('collections reducer state = ', action.type);
  switch (action.type) {
    case FETCH_MY_COLLECTIONS:
      return handleFetchCollectionList(state, action.payload);
    case FETCH_MY_COLLECTIONS_SUCCESS:
      return handleFetchCollectionListSuccess(state, action.payload.results);
    case FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS:
      return handleFetchCollectionListSuccess(state, action.payload.results);
    case FETCH_COLLECTIONS_FOLDERS.LOADING: {
      const { skip } = action.payload;

      if (skip === 0) {
        return {
          ...state,
          collectionsFoldersById: [],
          collectionsFoldersByHash: {},
          collectionsFoldersTotalCount: 0,
        };
      }

      return state;
    }
    case FETCH_COLLECTIONS_FOLDERS.SUCCESS:
      return handleFetchCollectionsFoldersListSuccess(state, action.payload);
    case FETCH_SHARED_COLLECTIONS_FOLDERS:
      return handleFetchSharedCollectionsFoldersList(state, action.payload);
    case FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS:
      return handleFetchSharedCollectionsFoldersListSuccess(
        state,
        action.payload.results,
      );
    case FETCH_POI_DETAIL_SUCCESS:
      return handleFetchPoiDetailSuccess(
        state,
        action.payload.folderObjectId,
        action.payload.poiObjectId,
        action.payload.results,
        action.payload.type,
      );
    case FETCH_POI_DETAIL_FAIL:
      // TODO
      // set poi detail of poi to null
      break;
    case FETCH_POI_DETAIL_FROM_POI_BANK:
      return {
        ...state,
        poiDetail: null,
      };
    case FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS:
      // console.log(
      //   ' FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS = payload',
      //   action.payload
      // );
      return handleFetchPoiDetailFromPoiBankSuccess(
        state,
        action.payload.folderObjectId,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results,
      );
    case FETCH_POI_DETAIL_FROM_POI_BANK_FAIL:
      // TODO
      return handleFetchPoiDetailFromPoiBankFail(
        state,
        action.payload.folderObjectId,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results,
      );
    case USER_LOG_OUT:
      return {
        collectionsById: [],
        collectionsByHash: {},
        collectionsSkip: 0,
        collectionsTotalCount: 0,
        sharedFoldersById: [],
        sharedFoldersByHash: {},
        sharedFoldersSkip: 0,
        sharedFoldersTotalCount: 0,
      };
    case CREATE_COLLECTIONS_FOLDER.SUCCESS: {
      const { _id } = action.payload;
      const ids = [_id, ...state.collectionsById];
      const newCollections = { ...state.collectionsByHash };
      newCollections[_id] = {
        ...action.payload,
        collectionsById: [],
        collectionsByHash: {},
        collectionsSkip: 0,
        collectionsTotalCount: 0,
      };
      return {
        ...state,
        collectionsById: ids,
        collectionsByHash: newCollections,
        collectionsTotalCount: ids.length,
      };
    }
    case DELETE_COLLECTIONS.SUCCESS: {
      const { ids, folderId } = action.payload;
      if (folderId) {
        const newCollectionsIds = [
          ...state.collectionsByHash[folderId].collectionsById,
        ];
        const newCollectionsHash = {
          ...state.collectionsByHash[folderId].collectionsByHash,
        };
        ids.forEach(id => {
          const idx = newCollectionsIds.indexOf(id);
          if (idx !== -1) {
            newCollectionsIds.splice(idx, 1);
          }
          delete newCollectionsHash[id];
        });

        return update(state, {
          collectionsByHash: {
            [folderId]: {
              collectionsById: { $set: newCollectionsIds },
              collectionsByHash: { $set: newCollectionsHash },
              collectionsTotalCount: {
                $set: parseInt(newCollectionsIds.length, 10),
              },
            },
          },
        });
      }

      const newCollectionsIds = [...state.collectionsById];
      const newCollectionsHash = { ...state.collectionsByHash };

      ids.forEach(id => {
        const idx = newCollectionsIds.indexOf(id);
        if (idx !== -1) {
          newCollectionsIds.splice(idx, 1);
        }
        delete newCollectionsHash[id];
      });

      return {
        ...state,
        collectionsById: newCollectionsIds,
        collectionsByHash: newCollectionsHash,
        collectionsTotalCount: newCollectionsIds.length,
      };
    }

    case MOVE_COLLECTIONS_TO_FOLDER.SUCCESS: {
      const { ids, fromFolderId } = action.payload;

      if (fromFolderId) {
        const newCollectionsIds = [
          ...state.collectionsByHash[fromFolderId]?.collectionsById,
        ];
        ids.forEach(id => {
          const idx = newCollectionsIds.indexOf(id);
          if (idx !== -1) {
            newCollectionsIds.splice(idx, 1);
          }
        });
        return update(state, {
          collectionsByHash: {
            [fromFolderId]: {
              collectionsById: { $set: newCollectionsIds },
              collectionsTotalCount: { $set: newCollectionsIds.length },
            },
          },
        });
      }

      const newCollectionsIds = [...state.collectionsById];
      ids.forEach(id => {
        const idx = newCollectionsIds.indexOf(id);
        if (idx !== -1) {
          newCollectionsIds.splice(idx, 1);
        }
      });

      return {
        ...state,
        collectionsById: newCollectionsIds,
        collectionsTotalCount: newCollectionsIds.length,
      };
    }
    case UPDATE_ALIAS_NAME_COLLECTION.SUCCESS: {
      const { id, aliasName, folderId, type } = action.payload;

      if (type !== TYPE_COLLECTIONS_LIST.SHARED) {
        if (!folderId) {
          return update(state, {
            collectionsByHash: {
              [id]: {
                aliasName: { $set: aliasName },
              },
            },
          });
        }

        return update(state, {
          collectionsByHash: {
            [folderId]: {
              collectionsByHash: {
                [id]: { aliasName: { $set: aliasName } },
              },
            },
          },
        });
      }

      return update(state, {
        sharedFoldersByHash: {
          [folderId]: {
            collectionsByHash: {
              [id]: { aliasName: { $set: aliasName } },
            },
          },
        },
      });
    }
    case UPDATE_FOLDER_NAME_COLLECTION.SUCCESS: {
      const { folderName, folderId, type } = action.payload;

      if (type !== TYPE_COLLECTIONS_LIST.SHARED) {
        return update(state, {
          collectionsByHash: {
            [folderId]: {
              folderName: { $set: folderName },
            },
          },
        });
      }

      return update(state, {
        sharedFoldersByHash: {
          [folderId]: {
            folderName: { $set: folderName },
          },
        },
      });
    }
    case UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.SUCCESS: {
      const { publicStatus, folderId, type } = action.payload;

      if (type !== TYPE_COLLECTIONS_LIST.SHARED) {
        return update(state, {
          collectionsByHash: {
            [folderId]: {
              publicStatus: { $set: publicStatus },
            },
          },
        });
      }

      return update(state, {
        sharedFoldersByHash: {
          [folderId]: {
            publicStatus: { $set: publicStatus },
          },
        },
      });
    }
    case ADD_POI_TO_MY_COLLECTION.SUCCESS: {
      const { _id } = action.payload;

      return update(state, {
        collectionsById: { $push: [_id] },
        collectionsByHash: { $merge: { [_id]: { ...action.payload } } },
        latestAddedId: { $set: _id },
      });
    }
    default:
      return state;
  }
  return state;
};

// reset data,skip and totalCount if fetch first page of collections
const handleFetchCollectionList = (state, payload) => {
  // console.log(' handleFetchCollectionList = ', payload);
  const { skip, folderObjectId } = payload;
  // console.log(' handleFetchCollectionList skip = ', skip);
  // get collections in folder
  if (folderObjectId && skip === '0') {
    return update(state, {
      collectionsByHash: {
        [folderObjectId]: {
          $set: { collectionsById: [], collectionsByHash: {} },
        },
      },
    });
  }

  // get collections for 1st page

  if (skip === '0') {
    // console.log(' handleFetchCollectionList skip = 0000');
    return {
      ...state,
      collectionsById: [],
      collectionsByHash: {},
      collectionsSkip: 0,
      collectionsTotalCount: 0,
    };
  }
  return state;
};

const handleFetchCollectionListSuccess = (state, results) => {
  // console.log('handleFetchCollectionListSuccess');
  const {
    folders,
    collections,
    collectionsFolderObjectId,
    skip,
    totalCount,
  } = results;
  const collectionsIdArray = [];
  const collectionsHash = {};
  if (folders) {
    folders.forEach(element => {
      if (element) {
        const folder = { ...element };
        // init folder object
        folder.isFolder = true;
        folder.collectionsById = [];
        folder.collectionsByHash = {};
        folder.collectionsSkip = 0;
        folder.collectionsTotalCount = 0;
        collectionsIdArray.push(folder._id);
        collectionsHash[folder._id] = folder;
      }
    });
  }

  if (collections) {
    collections.forEach(element => {
      if (element) {
        const collection = { ...element };
        collection.isFolder = false;
        collectionsIdArray.push(collection._id);
        collectionsHash[collection._id] = collection;
      }
    });
  }

  // console.log(
  //   'handleFetchCollectionListSuccess collectionsIdArray = ',
  //   collectionsIdArray
  // );
  // console.log(
  //   'handleFetchCollectionListSuccess collectionsHash = ',
  //   collectionsHash
  // );
  // console.log(
  //   'handleFetchCollectionListSuccess collectionsFolderObjectId = ',
  //   collectionsFolderObjectId
  // );
  if (collectionsFolderObjectId) {
    // set collections to specific folder
    const { collectionsByHash, sharedFoldersByHash } = state;
    if (collectionsByHash[collectionsFolderObjectId]) {
      // console.log(' folder = ', collectionsByHash[collectionsFolderObjectId]);
      return update(state, {
        collectionsByHash: {
          [collectionsFolderObjectId]: {
            collectionsById: { $set: collectionsIdArray },
            collectionsByHash: { $set: collectionsHash },
            collectionsSkip: { $set: parseInt(skip, 10) },
            collectionsTotalCount: { $set: parseInt(totalCount, 10) },
          },
        },
      });
    }

    if (sharedFoldersByHash[collectionsFolderObjectId]) {
      return update(state, {
        sharedFoldersByHash: {
          [collectionsFolderObjectId]: {
            collectionsById: { $set: collectionsIdArray },
            collectionsByHash: { $set: collectionsHash },
            collectionsSkip: { $set: parseInt(skip, 10) },
            collectionsTotalCount: { $set: parseInt(totalCount, 10) },
          },
        },
      });
    }
    return state;
  }

  return {
    ...state,
    collectionsById: [...state.collectionsById, ...collectionsIdArray],
    collectionsByHash: { ...state.collectionsByHash, ...collectionsHash },
    collectionsSkip: parseInt(skip, 10),
    collectionsTotalCount: parseInt(totalCount, 10),
  };
};

const handleFetchCollectionsFoldersListSuccess = (state, results) => {
  const { folders, totalCount } = results;
  const collectionsFoldersIdArray = [];
  const collectionsFoldersHash = {};

  if (folders) {
    folders.forEach(element => {
      if (element) {
        const folder = { ...element, isFolder: true };
        collectionsFoldersIdArray.push(folder._id);
        collectionsFoldersHash[folder._id] = folder;
      }
    });
  }

  return {
    ...state,
    collectionsFoldersById: [
      ...state.collectionsFoldersById,
      ...collectionsFoldersIdArray,
    ],
    collectionsFoldersByHash: {
      ...state.collectionsFoldersByHash,
      ...collectionsFoldersHash,
    },
    collectionsFoldersTotalCount: parseInt(totalCount, 10),
  };
};

// reset data,skip and totalCount if fetch first page of collections
const handleFetchSharedCollectionsFoldersList = (state, payload) => {
  const { skip } = payload;
  if (skip === '0') {
    return {
      ...state,
      sharedFoldersById: [],
      sharedFolderByHash: {},
      sharedFoldersSkip: 0,
      sharedFoldersTotalCount: 0,
    };
  }
  return state;
};

const handleFetchSharedCollectionsFoldersListSuccess = (state, results) => {
  const { folders, skip, totalCount } = results;
  const idArray = [];
  const hash = {};
  folders.forEach(element => {
    if (element) {
      const folder = { ...element };
      folder.isFolder = true;
      folder.collectionsById = [];
      folder.collectionsByHash = {};
      folder.collectionsSkip = 0;
      folder.collectionsTotalCount = 0;
      idArray.push(folder._id);
      hash[folder._id] = folder;
    }
  });

  const newState = update(state, {
    sharedFoldersById: { $push: idArray },
    sharedFoldersByHash: { $merge: hash },
    sharedFoldersSkip: { $set: parseInt(skip, 10) },
    sharedFoldersTotalCount: { $set: parseInt(totalCount, 10) },
  });
  // console.log(
  //   ' handleFetchSharedCollectionsFoldersListSuccess state = ',
  //   newState
  // );
  return newState;
};

// fetch poi detail
const handleFetchPoiDetailSuccess = (
  state,
  folderObjectId,
  poiObjectId,
  results,
  type,
) => {
  if (type !== POI_DETAIL_TYPE_FOR_COLLECTIONS) {
    return state;
  }

  // console.log(' handleFetchPoiDetailSuccess ');
  // console.log(' handleFetchPoiDetailSuccess results = ', results);
  // console.log(' handleFetchPoiDetailSuccess folderObjectId = ', folderObjectId);
  // console.log(' handleFetchPoiDetailSuccess poiObjectId = ', poiObjectId);
  return updateCollection(state, folderObjectId, poiObjectId, results);
};

// for set results to specific collection object
const updateCollection = (state, folderObjectId, poiObjectId, results) => {
  // update collection on the root folder
  const { collectionsByHash, sharedFoldersByHash } = state;
  if (!folderObjectId) {
    const poi = collectionsByHash[poiObjectId];
    // poi not found
    if (!poi) {
      return state;
    }
    const poiDetail = { ...poi, poiDetail: results };
    return update(state, {
      collectionsByHash: { [poiObjectId]: { poiDetail: { $set: results } } },
      poiDetail: { $set: poiDetail },
    });
  }

  // update collection inside folder
  // my folders
  if (collectionsByHash[folderObjectId]) {
    const poi =
      collectionsByHash[folderObjectId]?.collectionsByHash[poiObjectId];
    if (!poi) {
      return state;
    }

    const poiDetail = { ...poi, poiDetail: results };
    return update(state, {
      collectionsByHash: {
        [folderObjectId]: {
          collectionsByHash: {
            [poiObjectId]: { poiDetail: { $set: results } },
          },
        },
      },
      poiDetail: { $set: poiDetail },
    });
  }

  // groups
  if (sharedFoldersByHash[folderObjectId]) {
    const poi =
      sharedFoldersByHash[folderObjectId]?.collectionsByHash[poiObjectId];
    if (!poi) {
      return state;
    }

    const poiDetail = { ...poi, poiDetail: results };
    return update(state, {
      sharedFoldersByHash: {
        [folderObjectId]: {
          collectionsByHash: {
            [poiObjectId]: { poiDetail: { $set: results } },
          },
        },
      },
      poiDetail: { $set: poiDetail },
    });
  }

  return state;
};

// fetch poi detail from poi bank
const handleFetchPoiDetailFromPoiBankSuccess = (
  state,
  folderObjectId,
  poiObjectId,
  type,
  results,
) => {
  if (type !== POI_DETAIL_TYPE_FOR_COLLECTIONS) {
    return state;
  }
  // console.log(' handleFetchPoiDetailFromPoiBankSuccess');
  const poiDetail = { ...results };
  const { urls } = poiDetail;

  // urls
  if (urls) {
    for (let i = 0; i < results.urls.length; i++) {
      const url = results.urls[i];
      if (url.type === POI_BANK_NEXT_URL_TYPE_WEB_SITE) {
        poiDetail.website = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_FACEBOOK) {
        poiDetail.facebook = results.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_WIKI) {
        poiDetail.wiki = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_TWITTER) {
        poiDetail.twitter = url.url;
      }
    }
    delete poiDetail.urls;
  }

  return updateCollection(state, folderObjectId, poiObjectId, results);
};

const handleFetchPoiDetailFromPoiBankFail = (
  state,
  folderObjectId,
  poiObjectId,
  type,
  results,
) => {
  if (type !== POI_DETAIL_TYPE_FOR_COLLECTIONS) {
    return state;
  }

  const poi = state.collectionsByHash[poiObjectId];

  if (!poi) {
    return state;
  }
  return update(state, {
    collectionsByHash: { [poiObjectId]: { poiDetail: { $set: null } } },
  });
};
